import { z } from 'zod'
import { MarketValidation } from '../../../../../../../shared/domain/Market'
import { LanguageValidation } from '../../../../../../../shared/domain/Language'
import { NameValidation } from '../../../../../../../_kernel/Name'
import { FullNameValidation } from '../../../../../../../_kernel/FullName'
import { SlugValidation } from '../../../../../../../_kernel/Slug'
import { CountValidation } from '../../../../../../../_kernel/Count'
import { DescriptionValidation } from '../../../../../../../_kernel/Description'
import { PathValidation } from '../../../../../../../_kernel/Path'

export const GETTopDestinationsByBannerIdQuery = z.object({
  lang: LanguageValidation.shape.value,
  market: MarketValidation.shape.value,
})

const ImageValidation = z.union([
  z.object({
    portrait: PathValidation.shape.value,
    wide: PathValidation.shape.value.optional(),
  }),
  z.object({
    portrait: PathValidation.shape.value.optional(),
    wide: PathValidation.shape.value,
  }),
  z.object({
    portrait: PathValidation.shape.value,
    wide: PathValidation.shape.value,
  }),
])

export type GETTopDestinationsByBannerIdResponse = z.infer<
  typeof GETTopDestinationsByBannerIdResponse
>
export const GETTopDestinationsByBannerIdResponse = z.object({
  destinations: z
    .object({
      name: NameValidation.shape.value,
      full_name: FullNameValidation.shape.value,
      slug: SlugValidation.shape.value,
      properties_count: CountValidation.shape.value,
      description: DescriptionValidation.shape.value,
      images: ImageValidation,
    })
    .array(),
})
